/** Bottom tab bar shown on phones (below md); mirrors Sidebar's nav links. */

import { useNavItems } from "@client/components/layout/navItems";
import { Link } from "@tanstack/react-router";

export function MobileNav() {
  const navItems = useNavItems();

  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 flex border-t border-line bg-surface pb-[env(safe-area-inset-bottom)] md:hidden">
      {navItems.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          activeOptions={{ exact: item.exact ?? false }}
          className="flex min-w-0 flex-1 flex-col items-center gap-0.5 py-1.5 text-[10px] font-medium text-fg-3 no-underline hover:no-underline"
          activeProps={{ className: "text-fg-1" }}
        >
          <span className="relative">
            <svg
              width={20}
              height={20}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d={item.icon} />
            </svg>
            {item.badge != null && (
              <span
                className="tabular absolute -right-2 -top-1 rounded-full px-1 text-[9px] font-semibold leading-4"
                style={{
                  background: item.badgeRed ? "rgba(240,82,82,.2)" : "var(--color-app)",
                  color: item.badgeRed ? "var(--color-danger)" : "var(--color-fg-3)",
                }}
              >
                {item.badge}
              </span>
            )}
          </span>
          <span className="whitespace-nowrap tracking-tight">{item.label}</span>
        </Link>
      ))}
    </nav>
  );
}
